import { AfterViewInit, Component, ContentChildren, ElementRef, Input, QueryList } from '@angular/core';
import { Container } from '../container';

@Component({
  selector: 'screen-group-slider-item',
  template: `
    <ng-content></ng-content>
  `,
  styles: [
      `
      :host {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    `
  ]
})
export class SliderSimpleItemComponent {
  constructor() {

  }
}

@Component({
  selector: 'screen-group-slider',
  templateUrl: './slider.simple.component.html',
  styleUrls: ['./slider.simple.component.less']
})
export class SliderSimpleComponent extends Container implements AfterViewInit {

  private _initialized = false;
  private _sliderContainer: HTMLElement;
  private _length = 0;

  private _autoLoop = true;
  private _interval = 4000;
  private _intervalHandle;

  current = 0;
  idleArray = [];

  @ContentChildren(SliderSimpleItemComponent) items: QueryList<SliderSimpleItemComponent>;


  @Input()
  set autoLoop(param: boolean) {
    this._autoLoop = !!param;
    if (this._initialized) {
      this._hackAutoplay();
    }
  }

  @Input()
  set interval(param: number) {
    if (param > 1000 && this._interval !== param) {
      this._interval = param;
      this.start();
    }
  }

  private get width() {
    return this._elementRef.nativeElement.offsetWidth;
  }

  constructor(private _elementRef: ElementRef) {
    super();
  }

  ngAfterViewInit() {
    this._sliderContainer = this._elementRef.nativeElement.querySelector('.slider-container');

    this.addSubscription(() => {
      this.stop();
    });
    this.addSubscription(this.items.changes.subscribe(() => {
      this._init();
    }));

    this._init();
  }

  resize() {
    this._update();
  }

  /**
   * 开始播放  不管autoLoop的标志是true or false
   * 如果当前处于播放状态，则重新开始播放；
   */
  start() {
    this.stop();
    this._intervalHandle = setInterval(() => {
      // 更新current
      this.current = (this.current + 1) % this._length;
      this._update();
    }, this._interval);
  }

  stop() {
    if (this._intervalHandle) {
      clearInterval(this._intervalHandle);
      this._intervalHandle = 0;
    }
  }

  /**
   * 快捷按钮事件处理函数
   * @param index
   */
  pointerClick(index) {
    this.stop();
    this.goPage(index);
  }

  previous() {
    this.stop();
    const preIndex = this.current;
    this.current = preIndex === 0 ? this._length - 1 : preIndex - 1;
    this._update();
  }

  next() {
    this.stop();
    this.current = (this.current + 1) % this._length;
    this._update();
  }

  /**
   * 跳转到index索引处的图片，index从0开始计数
   * @param index
   */
  goPage(index) {
    this.current = index % this._length;
    this._update();
  }

  private _init() {
    if (this.items.length) {
      this.idleArray = new Array(this._length = this.items.length).fill('a');
      this._hackAutoplay();
    }
    this._initialized = true;
  }

  private _hackAutoplay() {
    if (this._autoLoop) {
      this.start();
    }
  }

  private _update() {
    this._sliderContainer.style.transform = `translateX(${-this.current * this.width}px)`;
  }
}
